var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg3DSticker2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 618,
    height: 383,
    viewBox: "0 0 618 383",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    clipPath: "url(#clip0_2121_2685)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329.311 -59.2965C319.494 -76.2994 297.753 -82.125 280.75 -72.3084C263.747 -62.4918 257.922 -40.7503 267.738 -23.7474C277.555 -6.7445 299.296 -0.918887 316.299 -10.7355C333.302 -20.5521 339.128 -42.2936 329.311 -59.2965Z",
    fill: "url(#paint0_linear_2121_2685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.626 -45.8959C325.792 -62.9302 304.01 -68.7667 286.976 -58.9319C269.941 -49.0971 264.105 -27.3153 273.94 -10.281C283.774 6.7534 305.556 12.5898 322.591 2.75504C339.625 -7.07975 345.461 -28.8615 335.626 -45.8959Z",
    fill: "url(#paint1_linear_2121_2685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.828 -31.0835C332.977 -48.1469 311.158 -53.9932 294.094 -44.1417C277.031 -34.2901 271.185 -12.4712 281.036 4.59222C290.888 21.6556 312.707 27.502 329.77 17.6504C346.834 7.79886 352.68 -14.02 342.828 -31.0835Z",
    fill: "url(#paint2_linear_2121_2685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.523 -15.3687C337.655 -32.4612 315.799 -38.3175 298.706 -28.4492C281.614 -18.5808 275.758 3.27526 285.626 20.3677C295.494 37.4602 317.35 43.3165 334.443 33.4482C351.535 23.5798 357.392 1.72378 347.523 -15.3687Z",
    fill: "url(#paint3_linear_2121_2685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.748 1.00068C339.861 -16.1233 317.965 -21.9904 300.841 -12.1039C283.717 -2.21734 277.85 19.679 287.737 36.8029C297.623 53.9269 319.519 59.794 336.643 49.9075C353.767 40.021 359.634 18.1246 349.748 1.00068Z",
    fill: "url(#paint4_linear_2121_2685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.576 17.8522C339.672 0.699156 317.739 -5.17789 300.586 4.7254C283.433 14.6287 277.556 36.5622 287.459 53.7152C297.362 70.8682 319.296 76.7452 336.449 66.8419C353.602 56.9387 359.479 35.0052 349.576 17.8522Z",
    fill: "url(#paint5_linear_2121_2685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.087 35.0279C337.167 17.8458 315.196 11.9588 298.014 21.8789C280.832 31.7989 274.945 53.7695 284.865 70.9516C294.785 88.1337 316.756 94.0207 333.938 84.1006C351.12 74.1806 357.007 52.2099 347.087 35.0279Z",
    fill: "url(#paint6_linear_2121_2685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.382 52.2817C332.445 35.0706 310.437 29.1736 293.226 39.1104C276.015 49.0473 270.118 71.0551 280.055 88.2662C289.991 105.477 311.999 111.374 329.21 101.437C346.422 91.5006 352.318 69.4928 342.382 52.2817Z",
    fill: "url(#paint7_linear_2121_2685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.939 68.4714C325.984 51.2288 303.936 45.321 286.694 55.276C269.451 65.2311 263.543 87.2791 273.498 104.522C283.453 121.764 305.501 127.672 322.744 117.717C339.987 107.762 345.894 85.714 335.939 68.4714Z",
    fill: "url(#paint8_linear_2121_2685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.888 83.565C317.916 66.2934 295.831 60.3757 278.559 70.3475C261.288 80.3193 255.37 102.404 265.342 119.676C275.314 136.948 297.399 142.865 314.671 132.894C331.942 122.922 337.86 100.837 327.888 83.565Z",
    fill: "url(#paint9_linear_2121_2685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.366 97.5103C308.378 80.2096 286.255 74.2819 268.955 84.2705C251.654 94.2591 245.726 116.381 255.715 133.682C265.703 150.983 287.826 156.91 305.126 146.922C322.427 136.933 328.355 114.811 318.366 97.5103Z",
    fill: "url(#paint10_linear_2121_2685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.499 110.223C297.492 92.8912 275.33 86.9528 257.998 96.9595C240.665 106.966 234.727 129.129 244.734 146.461C254.74 163.793 276.903 169.732 294.235 159.725C311.567 149.718 317.506 127.556 307.499 110.223Z",
    fill: "url(#paint11_linear_2121_2685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.416 121.657C285.392 104.296 263.193 98.3473 245.831 108.371C228.47 118.394 222.522 140.594 232.545 157.955C242.569 175.317 264.768 181.265 282.13 171.241C299.491 161.218 305.439 139.018 295.416 121.657Z",
    fill: "url(#paint12_linear_2121_2685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.244 131.727C272.203 114.337 249.966 108.378 232.576 118.419C215.186 128.459 209.227 150.696 219.268 168.086C229.308 185.477 251.545 191.435 268.935 181.395C286.326 171.354 292.284 149.117 282.244 131.727Z",
    fill: "url(#paint13_linear_2121_2685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.116 140.374C258.057 122.952 235.78 116.983 218.358 127.041C200.936 137.1 194.967 159.377 205.026 176.799C215.084 194.221 237.361 200.19 254.783 190.131C272.205 180.073 278.174 157.796 268.116 140.374Z",
    fill: "url(#paint14_linear_2121_2685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.148 147.538C243.072 130.087 220.758 124.108 203.307 134.183C185.856 144.258 179.877 166.573 189.952 184.024C200.028 201.474 222.342 207.453 239.793 197.378C257.244 187.303 263.223 164.989 253.148 147.538Z",
    fill: "url(#paint15_linear_2121_2685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.477 153.143C227.385 135.663 205.034 129.674 187.554 139.766C170.074 149.858 164.085 172.21 174.177 189.69C184.269 207.17 206.62 213.159 224.1 203.067C241.58 192.975 247.569 170.623 237.477 153.143Z",
    fill: "url(#paint16_linear_2121_2685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.234 157.126C211.124 139.615 188.732 133.615 171.221 143.725C153.709 153.835 147.71 176.227 157.82 193.738C167.93 211.25 190.322 217.249 207.833 207.139C225.345 197.029 231.344 174.637 221.234 157.126Z",
    fill: "url(#paint17_linear_2121_2685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.542 159.419C194.415 141.878 171.987 135.869 154.446 145.996C136.906 156.123 130.896 178.551 141.023 196.092C151.15 213.632 173.579 219.642 191.119 209.515C208.66 199.388 214.669 176.959 204.542 159.419Z",
    fill: "url(#paint18_linear_2121_2685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.525 159.954C177.382 142.384 154.916 136.365 137.346 146.508C119.777 156.652 113.757 179.118 123.901 196.688C134.044 214.257 156.51 220.277 174.08 210.133C191.649 199.989 197.669 177.523 187.525 159.954Z",
    fill: "url(#paint19_linear_2121_2685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.326 158.667C160.164 141.066 137.658 135.035 120.057 145.197C102.456 155.359 96.4256 177.866 106.588 195.467C116.749 213.068 139.256 219.098 156.857 208.936C174.458 198.774 180.488 176.268 170.326 158.667Z",
    fill: "url(#paint20_linear_2121_2685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.953 155.468C142.774 137.838 120.231 131.797 102.601 141.976C84.9707 152.155 78.9302 174.698 89.1089 192.328C99.2876 209.958 121.831 215.999 139.461 205.82C157.091 195.641 163.132 173.098 152.953 155.468Z",
    fill: "url(#paint21_linear_2121_2685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.904 150.288C125.708 132.629 103.128 126.578 85.4686 136.774C67.8095 146.969 61.759 169.55 71.9545 187.209C82.15 204.868 104.731 210.919 122.39 200.723C140.049 190.528 146.099 167.947 135.904 150.288Z",
    fill: "url(#paint22_linear_2121_2685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.197 143.251C109.983 125.561 87.3622 119.499 69.6717 129.713C51.9811 139.927 45.9199 162.547 56.1335 180.238C66.3472 197.929 88.968 203.99 106.659 193.776C124.349 183.562 130.41 160.942 120.197 143.251Z",
    fill: "url(#paint23_linear_2121_2685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.017 134.376C95.7862 116.656 73.1283 110.585 55.4086 120.816C37.689 131.046 31.6178 153.704 41.8482 171.424C52.0787 189.143 74.7367 195.214 92.4563 184.984C110.176 174.754 116.247 152.096 106.017 134.376Z",
    fill: "url(#paint24_linear_2121_2685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5768 123.665C83.3297 105.916 60.6345 99.8351 42.8858 110.082C25.1372 120.33 19.056 143.025 29.3032 160.773C39.5504 178.522 62.2456 184.603 79.9942 174.356C97.7429 164.109 103.824 141.414 93.5768 123.665Z",
    fill: "url(#paint25_linear_2121_2685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.0775 111.118C72.8135 93.3403 50.0812 87.2492 32.3035 97.5131C14.5258 107.777 8.43467 130.509 18.6986 148.287C28.9626 166.065 51.6949 172.156 69.4726 161.892C87.2503 151.628 93.3415 128.896 83.0775 111.118Z",
    fill: "url(#paint26_linear_2121_2685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.765 96.8311C64.4829 79.0219 41.7103 72.92 23.9011 83.2022C6.09191 93.4843 -0.00997599 116.257 10.2722 134.066C20.5543 151.875 43.3269 157.977 61.1361 147.695C78.9453 137.413 85.0472 114.64 74.765 96.8311Z",
    fill: "url(#paint27_linear_2121_2685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0283 81.4795C58.7294 63.6412 35.9197 57.5294 18.0815 67.8283C0.243207 78.1273 -5.86864 100.937 4.43028 118.775C14.7292 136.613 37.5389 142.725 55.3772 132.426C73.2154 122.127 79.3273 99.3178 69.0283 81.4795Z",
    fill: "url(#paint28_linear_2121_2685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8561 65.3505C55.5404 47.4832 32.6936 41.3614 14.8262 51.6771C-3.04108 61.9928 -9.16288 84.8396 1.15282 102.707C11.4685 120.574 34.3154 126.696 52.1827 116.38C70.05 106.065 76.1718 83.2178 65.8561 65.3505Z",
    fill: "url(#paint29_linear_2121_2685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.155 48.6183C54.8211 30.7195 31.934 24.5869 14.0352 34.9208C-3.8636 45.2547 -9.99617 68.1418 0.337701 86.0406C10.6716 103.939 33.5587 110.072 51.4575 99.7381C69.3563 89.4042 75.4888 66.5171 65.155 48.6183Z",
    fill: "url(#paint30_linear_2121_2685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8245 31.462C56.4739 13.5342 33.5496 7.3916 15.6218 17.7422C-2.30606 28.0929 -8.44859 51.0172 1.90206 68.945C12.2527 86.8729 35.177 93.0154 53.1048 82.6647C71.0327 72.3141 77.1752 49.3899 66.8245 31.462Z",
    fill: "url(#paint31_linear_2121_2685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7764 14.0557C60.4089 -3.90123 37.4475 -10.0537 19.4906 0.313681C1.53369 10.6811 -4.61879 33.6425 5.74863 51.5994C16.1161 69.5563 39.0775 75.7088 57.0344 65.3414C74.9913 54.974 81.1438 32.0126 70.7764 14.0557Z",
    fill: "url(#paint32_linear_2121_2685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6621 -2.76245C66.2765 -20.7508 43.2749 -26.9141 25.2865 -16.5285C7.2981 -6.14291 1.13482 16.8587 11.5204 34.8471C21.906 52.8355 44.9077 58.9988 62.896 48.6132C80.8844 38.2276 87.0477 15.2259 76.6621 -2.76245Z",
    fill: "url(#paint33_linear_2121_2685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1208 -18.4578C73.7184 -36.4753 50.6796 -42.6485 32.6621 -32.2462C14.6447 -21.8438 8.47146 1.19504 18.8738 19.2125C29.2762 37.2299 52.315 43.4032 70.3324 33.0008C88.3499 22.5984 94.5231 -0.440401 84.1208 -18.4578Z",
    fill: "url(#paint34_linear_2121_2685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.0735 -33.0829C82.6544 -51.1294 59.5784 -57.3126 41.5319 -46.8935C23.4854 -36.4743 17.3022 -13.3983 27.7214 4.64815C38.1405 22.6947 61.2165 28.8778 79.263 18.4587C97.3095 8.03953 103.493 -15.0364 93.0735 -33.0829Z",
    fill: "url(#paint35_linear_2121_2685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.401 -46.5651C92.9634 -64.6431 69.8472 -70.8371 51.7692 -60.3998C33.6912 -49.9624 27.4972 -26.8462 37.9346 -8.76825C48.3719 9.30973 71.4881 15.5037 89.5661 5.0664C107.644 -5.37093 113.838 -28.4872 103.401 -46.5651Z",
    fill: "url(#paint36_linear_2121_2685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.977 -58.8113C104.522 -76.9183 81.3691 -83.1222 63.262 -72.6682C45.155 -62.2141 38.9511 -39.0607 49.4052 -20.9536C59.8593 -2.84661 83.0126 3.35731 101.12 -7.09679C119.227 -17.5509 125.431 -40.7042 114.977 -58.8113Z",
    fill: "url(#paint37_linear_2121_2685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.678 -69.7606C117.207 -87.8967 94.0169 -94.1106 75.8809 -83.6397C57.7448 -73.1688 51.5309 -49.9783 62.0018 -31.8422C72.4726 -13.7061 95.6632 -7.49223 113.799 -17.9631C131.935 -28.434 138.149 -51.6245 127.678 -69.7606Z",
    fill: "url(#paint38_linear_2121_2685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.857 -60.9244C318.162 -79.4479 294.477 -85.7945 275.953 -75.1C257.429 -64.4054 251.083 -40.7195 261.777 -22.196C272.472 -3.67251 296.158 2.6741 314.681 -8.02045C333.205 -18.715 339.552 -42.4009 328.857 -60.9244Z",
    fill: "url(#paint39_linear_2121_2685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.416 -47.4261C327.703 -65.9811 303.977 -72.3385 285.422 -61.6258C266.867 -50.9131 260.509 -27.1869 271.222 -8.63193C281.935 9.92305 305.661 16.2805 324.216 5.56774C342.771 -5.14499 349.128 -28.8712 338.416 -47.4261Z",
    fill: "url(#paint40_linear_2121_2685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.893 -35.0786C336.163 -53.6626 312.4 -60.03 293.816 -49.3005C275.232 -38.571 268.864 -14.8077 279.594 3.77638C290.323 22.3604 314.087 28.7278 332.671 17.9983C351.255 7.2688 357.622 -16.4945 346.893 -35.0786Z",
    fill: "url(#paint41_linear_2121_2685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.07 -24.3872C346.324 -43.0003 322.523 -49.3777 303.91 -38.6314C285.297 -27.8851 278.92 -4.08464 289.666 14.5285C300.412 33.1416 324.213 39.5189 342.826 28.7726C361.439 18.0263 367.816 -5.77414 357.07 -24.3872Z",
    fill: "url(#paint42_linear_2121_2685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.834 -15.2913C358.069 -33.9359 334.229 -40.324 315.584 -29.5595C296.94 -18.7951 290.551 5.04565 301.316 23.6902C312.08 42.3348 335.921 48.7229 354.566 37.9585C373.21 27.194 379.598 3.35328 368.834 -15.2913Z",
    fill: "url(#paint43_linear_2121_2685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.024 -7.76794C371.243 -26.4416 347.365 -32.8396 328.691 -22.0584C310.018 -11.2772 303.62 12.6007 314.401 31.2743C325.182 49.948 349.06 56.346 367.733 45.5648C386.407 34.7836 392.805 10.9057 382.024 -7.76794Z",
    fill: "url(#paint44_linear_2121_2685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.483 -1.79928C385.685 -20.502 361.77 -26.91 343.067 -16.112C324.364 -5.31398 317.956 18.6011 328.754 37.3038C339.552 56.0064 363.467 62.4145 382.17 51.6165C400.873 40.8185 407.281 16.9034 396.483 -1.79928Z",
    fill: "url(#paint45_linear_2121_2685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.058 2.62088C401.242 -16.1133 377.286 -22.5321 358.552 -11.7159C339.818 -0.899739 333.399 23.0555 344.215 41.7897C355.032 60.5239 378.987 66.9427 397.721 56.1265C416.455 45.3103 422.874 21.355 412.058 2.62088Z",
    fill: "url(#paint46_linear_2121_2685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.591 5.50754C417.758 -13.2557 393.765 -19.6845 375.002 -8.85151C356.239 1.98144 349.81 25.9739 360.643 44.7371C371.476 63.5003 395.468 69.9291 414.232 59.0961C432.995 48.2632 439.424 24.2708 428.591 5.50754Z",
    fill: "url(#paint47_linear_2121_2685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.924 6.87464C435.075 -11.9176 411.045 -18.3564 392.253 -7.50663C373.46 3.3431 367.022 27.3727 377.871 46.165C388.721 64.9572 412.751 71.396 431.543 60.5462C450.335 49.6965 456.774 25.6669 445.924 6.87464Z",
    fill: "url(#paint48_linear_2121_2685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.914 6.73619C453.046 -12.0876 428.976 -18.5371 410.152 -7.66917C391.328 3.19873 384.879 27.2686 395.747 46.0923C406.615 64.9161 430.684 71.3656 449.508 60.4977C468.332 49.6298 474.782 25.5599 463.914 6.73619Z",
    fill: "url(#paint49_linear_2121_2685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.384 5.10332C471.499 -13.7495 447.392 -20.209 428.539 -9.32429C409.687 1.56038 403.227 25.6674 414.112 44.5202C424.997 63.373 449.104 69.8325 467.956 58.9478C486.809 48.0631 493.269 23.9561 482.384 5.10332Z",
    fill: "url(#paint50_linear_2121_2685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.195 1.99386C490.294 -16.888 466.15 -23.3574 447.268 -12.456C428.386 -1.55452 421.916 22.5896 432.818 41.4715C443.719 60.3534 467.863 66.8228 486.745 55.9213C505.627 45.0199 512.097 20.8757 501.195 1.99386Z",
    fill: "url(#paint51_linear_2121_2685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.177 -2.58045C509.259 -21.4914 485.078 -27.9707 466.167 -17.0525C447.256 -6.13429 440.776 18.047 451.695 36.9579C462.613 55.8689 486.794 62.3483 505.705 51.43C524.616 40.5118 531.095 16.3305 520.177 -2.58045Z",
    fill: "url(#paint52_linear_2121_2685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.196 -8.60951C528.259 -27.5519 504.038 -34.0421 485.095 -23.1057C466.153 -12.1693 459.663 12.0523 470.599 30.9947C481.536 49.9371 505.757 56.4273 524.7 45.4909C543.642 34.5545 550.132 10.3329 539.196 -8.60951Z",
    fill: "url(#paint53_linear_2121_2685)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2121_2685",
    x1: 311.046,
    y1: -8.19103,
    x2: 286.205,
    y2: -74.8085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2121_2685",
    x1: 322.173,
    y1: 2.8709,
    x2: 287.046,
    y2: -59.0894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2121_2685",
    x1: 324.718,
    y1: 20.0492,
    x2: 299.113,
    y2: -46.5496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2121_2685",
    x1: 323.982,
    y1: 37.4843,
    x2: 309.244,
    y2: -32.4526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2121_2685",
    x1: 320.776,
    y1: 54.6263,
    x2: 316.667,
    y2: -16.8551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2121_2685",
    x1: 315.52,
    y1: 71.4468,
    x2: 321.371,
    y2: -0.0350502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2121_2685",
    x1: 308.416,
    y1: 87.9803,
    x2: 323.341,
    y2: 17.7002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2121_2685",
    x1: 299.738,
    y1: 104.458,
    x2: 322.778,
    y2: 36.2713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2121_2685",
    x1: 289.43,
    y1: 119.05,
    x2: 319.933,
    y2: 53.7257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2121_2685",
    x1: 277.829,
    y1: 132.403,
    x2: 315.371,
    y2: 70.7053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2121_2685",
    x1: 265.011,
    y1: 144.365,
    x2: 309.074,
    y2: 86.9819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2121_2685",
    x1: 251.116,
    y1: 154.561,
    x2: 301.12,
    y2: 102.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2121_2685",
    x1: 236.35,
    y1: 163.164,
    x2: 291.677,
    y2: 116.161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2121_2685",
    x1: 220.79,
    y1: 170.367,
    x2: 280.788,
    y2: 129.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2121_2685",
    x1: 204.614,
    y1: 175.888,
    x2: 268.619,
    y2: 141.107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2121_2685",
    x1: 187.785,
    y1: 179.977,
    x2: 255.123,
    y2: 151.864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2121_2685",
    x1: 170.921,
    y1: 181.873,
    x2: 240.907,
    y2: 160.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2121_2685",
    x1: 153.499,
    y1: 182.408,
    x2: 225.403,
    y2: 168.587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2121_2685",
    x1: 136.166,
    y1: 180.948,
    x2: 209.242,
    y2: 174.657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2121_2685",
    x1: 119.018,
    y1: 177.592,
    x2: 192.477,
    y2: 179.015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2121_2685",
    x1: 102.142,
    y1: 172.383,
    x2: 175.154,
    y2: 181.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2121_2685",
    x1: 85.3601,
    y1: 165.305,
    x2: 157.068,
    y2: 182.414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2121_2685",
    x1: 69.102,
    y1: 155.974,
    x2: 138.385,
    y2: 181.533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2121_2685",
    x1: 55.593,
    y1: 144.509,
    x2: 121.024,
    y2: 179.007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2121_2685",
    x1: 43.8369,
    y1: 131.034,
    x2: 103.713,
    y2: 174.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2121_2685",
    x1: 35.384,
    y1: 115.991,
    x2: 87.7659,
    y2: 168.574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2121_2685",
    x1: 29.3533,
    y1: 99.3507,
    x2: 72.3449,
    y2: 160.003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2121_2685",
    x1: 26.5919,
    y1: 81.968,
    x2: 58.6755,
    y2: 149.172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2121_2685",
    x1: 26.5975,
    y1: 64.4151,
    x2: 47.059,
    y2: 136.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2121_2685",
    x1: 29.1242,
    y1: 47.1105,
    x2: 38.0352,
    y2: 121.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_2121_2685",
    x1: 33.744,
    y1: 29.9829,
    x2: 31.7719,
    y2: 104.796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_2121_2685",
    x1: 40.3225,
    y1: 13.3904,
    x2: 28.4402,
    y2: 87.4087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_2121_2685",
    x1: 48.6198,
    y1: -3.39417,
    x2: 27.9103,
    y2: 68.781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_2121_2685",
    x1: 58.3286,
    y1: -18.7215,
    x2: 29.8368,
    y2: 50.8872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_2121_2685",
    x1: 69.4042,
    y1: -32.8233,
    x2: 33.6166,
    y2: 33.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_2121_2685",
    x1: 81.7956,
    y1: -45.555,
    x2: 39.1729,
    y2: 16.7173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_2121_2685",
    x1: 95.1292,
    y1: -56.4359,
    x2: 46.1788,
    y2: 1.16199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_2121_2685",
    x1: 109.513,
    y1: -65.9988,
    x2: 54.8006,
    y2: -13.6598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_2121_2685",
    x1: 124.905,
    y1: -74.2187,
    x2: 65.0311,
    y2: -27.675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_2121_2685",
    x1: 319.956,
    y1: -11.9544,
    x2: 270.393,
    y2: -71.4843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_2121_2685",
    x1: 324.45,
    y1: 5.47156,
    x2: 285.223,
    y2: -61.4701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_2121_2685",
    x1: 337.566,
    y1: 14.5308,
    x2: 288.799,
    y2: -45.972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_2121_2685",
    x1: 352.171,
    y1: 21.1826,
    x2: 294.509,
    y2: -31.1018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_2121_2685",
    x1: 367.429,
    y1: 25.8804,
    x2: 302.665,
    y2: -17.5241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_2121_2685",
    x1: 383.01,
    y1: 28.8444,
    x2: 312.924,
    y2: -5.58148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_2121_2685",
    x1: 399.446,
    y1: 30.5826,
    x2: 325.59,
    y2: 4.84864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_2121_2685",
    x1: 416.369,
    y1: 30.9898,
    x2: 340.021,
    y2: 13.4476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_2121_2685",
    x1: 433.351,
    y1: 30.0619,
    x2: 355.523,
    y2: 20.1333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_2121_2685",
    x1: 451.113,
    y1: 27.9497,
    x2: 372.579,
    y2: 25.0837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_2121_2685",
    x1: 468.901,
    y1: 24.5667,
    x2: 390.28,
    y2: 28.2606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_2121_2685",
    x1: 487.267,
    y1: 19.9012,
    x2: 409.054,
    y2: 29.7401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_2121_2685",
    x1: 505.943,
    y1: 13.8706,
    x2: 428.554,
    y2: 29.5172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_2121_2685",
    x1: 523.845,
    y1: 6.6468,
    x2: 447.65,
    y2: 27.8204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_2121_2685",
    x1: 542.078,
    y1: -2.01697,
    x2: 467.441,
    y2: 24.4868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFE781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2121_2685"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 546.754,
    height: 546.754,
    fill: "white",
    transform: "translate(143.723 382.848) rotate(-120)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3DSticker2);
export default __webpack_public_path__ + "static/media/3d-sticker2.040da4aaf18937ba10db7221af21ea19.svg";
export { ForwardRef as ReactComponent };